module.exports = __webpack_public_path__ + "static/media/pr_details4.ca36eeed.jpg";